
import { useLanguage } from "@/contexts/LanguageContext";
import { formatNumber } from "@/utils/formatNumber";
import { CustomTooltipProps } from "./types";

export const CustomTooltip = ({ active, payload, label, metric, color }: CustomTooltipProps) => {
  const { language } = useLanguage();
  
  if (active && payload && payload.length) {
    return (
      <div className="bg-card dark:bg-card p-3 border border-border rounded-lg shadow-lg">
        <p className="text-sm font-medium mb-1 text-foreground">
          {language === 'ar' ? `اليوم ${label}` : `Day ${label}`}
        </p>
        <p className="text-sm" style={{ color }}>
          {metric}: {formatNumber(payload[0].value, language)}
        </p>
      </div>
    );
  }
  return null;
};
